import File from "@/scripts/models/file.model";
export default class ProjectAccountabilityHeroConfig {
  constructor() {
    this.id = 0;
    this.heroFile = new File();
    this.primaryText = "";
    this.supportText = "";
  }
}
